module.exports = __webpack_public_path__ + "fonts/800-italic-greek.7b01eaa.woff2";